<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Usuarios</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Gestión de cuentas y perfiles RBAC</span>
    </div>
  </div>

  <div class="d-flex my-xl-auto right-content align-items-center gap-2 flex-wrap">
    <button class="btn btn-outline-secondary" type="button" (click)="cargarCatalogosYUsuarios()" [disabled]="cargando">
      Recargar
    </button>
    <button class="btn btn-primary" type="button" (click)="abrirNuevo()" [disabled]="!canWrite">
      Nuevo usuario
    </button>
  </div>
</div>

<div class="row row-sm stats-row">
  <div class="col-sm-4">
    <div class="card stat-card">
      <div class="card-body">
        <small>Total usuarios</small>
        <h3>{{ totalUsuarios }}</h3>
      </div>
    </div>
  </div>
  <div class="col-sm-4">
    <div class="card stat-card stat-ok">
      <div class="card-body">
        <small>Activos</small>
        <h3>{{ totalActivos }}</h3>
      </div>
    </div>
  </div>
  <div class="col-sm-4">
    <div class="card stat-card stat-off">
      <div class="card-body">
        <small>Inactivos</small>
        <h3>{{ totalInactivos }}</h3>
      </div>
    </div>
  </div>
</div>

<div class="card users-card">
  <div class="card-body">
    <div class="filters row g-2 align-items-end">
      <div class="col-lg-4 col-md-6">
        <label class="form-label">Buscar</label>
        <input class="form-control" [value]="q" (input)="onQChange($event)" placeholder="Nombre o usuario" />
      </div>
      <div class="col-lg-3 col-md-6">
        <label class="form-label">Perfil</label>
        <select class="form-select" [value]="filtroProfileId" (change)="onFiltroProfileChange($event)">
          <option value="">Todos</option>
          @for (p of profiles; track p) {
            <option [value]="p.id">{{ p.name }}</option>
          }
        </select>
      </div>
      <div class="col-lg-2 col-md-6">
        <label class="form-label">Estado</label>
        <select class="form-select" [value]="filtroEstado" (change)="onFiltroEstadoChange($event)">
          <option value="">Todos</option>
          <option value="1">Activo</option>
          <option value="0">Inactivo</option>
        </select>
      </div>
      <div class="col-lg-2 col-md-6">
        <label class="form-label">Por página</label>
        <select class="form-select" [value]="pageSize" (change)="onPageSizeChange($event)">
          @for (size of pageSizeOptions; track size) {
            <option [value]="size">{{ size }}</option>
          }
        </select>
      </div>
    </div>

    <div class="table-responsive mt-3 d-none d-lg-block">
      <table class="table table-striped align-middle">
        <thead>
          <tr>
            <th>#</th>
            <th>Nombre</th>
            <th>Usuario</th>
            <th>Perfil</th>
            <th>Sucursal</th>
            <th>Estado</th>
            <th>Último login</th>
            <th class="text-end">Acciones</th>
          </tr>
        </thead>
        <tbody>
          @if (cargando) {
            <tr>
              <td colspan="8" class="text-center py-4">
                <div class="spinner-border spinner-border-sm" role="status"></div>
                <span class="ms-2">Cargando...</span>
              </td>
            </tr>
          }

          @if (!cargando && usuariosFiltrados.length === 0) {
            <tr>
              <td colspan="8" class="text-center py-4 text-muted">No hay usuarios para mostrar</td>
            </tr>
          }

          @for (row of usuariosPaginados; track row; let i = $index) {
            <tr>
              <td>{{ startRow + i }}</td>
              <td>
                <div class="user-cell">
                  <img [src]="resolveFotoUrl(row.foto)" alt="foto" class="avatar" />
                  <div>
                    <div class="name">{{ row.nombre }}</div>
                    <small class="text-muted">ID {{ row.id }}</small>
                  </div>
                </div>
              </td>
              <td>{{ row.usuario }}</td>
              <td>{{ row.perfil || getProfileName(row.profile_id) }}</td>
              <td>{{ row.sucursal || '-' }}</td>
              <td>
                <span class="status-chip" [class.status-chip--on]="isActive(row)" [class.status-chip--off]="!isActive(row)">
                  {{ isActive(row) ? 'Activo' : 'Inactivo' }}
                </span>
              </td>
              <td>{{ formatDate(row.ultimo_login) }}</td>
              <td class="text-end">
                <div class="btn-group btn-group-sm">
                  <button class="btn btn-outline-secondary" type="button" (click)="cambiarEstado(row)" [disabled]="!canWrite">
                    {{ isActive(row) ? 'Desactivar' : 'Activar' }}
                  </button>
                  <button class="btn btn-outline-secondary" type="button" (click)="abrirEdicion(row)" [disabled]="!canWrite">Editar</button>
                  <button class="btn btn-outline-danger" type="button" (click)="eliminar(row)" [disabled]="!canWrite">Eliminar</button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="users-mobile-list d-lg-none mt-3">
      @if (cargando) {
        <div class="text-center py-4">
          <div class="spinner-border spinner-border-sm" role="status"></div>
          <span class="ms-2">Cargando...</span>
        </div>
      }

      @if (!cargando && usuariosFiltrados.length === 0) {
        <div class="text-center py-4 text-muted">
          No hay usuarios para mostrar
        </div>
      }

      @for (row of usuariosPaginados; track row; let i = $index) {
        <div class="user-mobile-card">
          <div class="user-mobile-top">
            <div class="user-mobile-index">#{{ startRow + i }}</div>
            <span class="status-chip" [class.status-chip--on]="isActive(row)" [class.status-chip--off]="!isActive(row)">
              {{ isActive(row) ? 'Activo' : 'Inactivo' }}
            </span>
          </div>
          <div class="user-mobile-main">
            <img [src]="resolveFotoUrl(row.foto)" alt="foto" class="avatar" />
            <div>
              <div class="name">{{ row.nombre }}</div>
              <small class="text-muted">ID {{ row.id }}</small>
            </div>
          </div>
          <div class="user-mobile-grid">
            <div><small>Usuario</small><strong>{{ row.usuario }}</strong></div>
            <div><small>Perfil</small><strong>{{ row.perfil || getProfileName(row.profile_id) }}</strong></div>
            <div><small>Sucursal</small><strong>{{ row.sucursal || '-' }}</strong></div>
            <div><small>Último login</small><strong>{{ formatDate(row.ultimo_login) }}</strong></div>
          </div>
          <div class="user-mobile-actions">
            <button class="btn btn-sm btn-outline-secondary" type="button" (click)="cambiarEstado(row)" [disabled]="!canWrite">
              {{ isActive(row) ? 'Desactivar' : 'Activar' }}
            </button>
            <button class="btn btn-sm btn-outline-secondary" type="button" (click)="abrirEdicion(row)" [disabled]="!canWrite">Editar</button>
            <button class="btn btn-sm btn-outline-danger" type="button" (click)="eliminar(row)" [disabled]="!canWrite">Eliminar</button>
          </div>
        </div>
      }
    </div>

    @if (!cargando && usuariosFiltrados.length > 0) {
      <div class="pager">
        <small class="text-muted">
          Mostrando {{ startRow }} - {{ endRow }} de {{ usuariosFiltrados.length }} usuarios
        </small>
        <div class="pager-actions">
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="prevPage()" [disabled]="currentPage <= 1">
            Anterior
          </button>
          <span class="pager-page">Página {{ currentPage }} de {{ totalPages }}</span>
          <button class="btn btn-sm btn-outline-secondary" type="button" (click)="nextPage()" [disabled]="currentPage >= totalPages">
            Siguiente
          </button>
        </div>
      </div>
    }
  </div>
</div>

@if (modalAbierto) {
  <div class="modal-overlay" (click)="cerrarModal()">
    <div class="modal-panel" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h5 class="modal-title">{{ modoEdicion ? 'Editar usuario' : 'Nuevo usuario' }}</h5>
        <button class="btn btn-sm btn-outline-secondary" type="button" (click)="cerrarModal()">Cerrar</button>
      </div>
      <div class="modal-body">
        @if (cargandoEdicion) {
          <div class="text-center py-4">
            <div class="spinner-border spinner-border-sm" role="status"></div>
            <span class="ms-2">Cargando datos del usuario...</span>
          </div>
        }
        @if (!cargandoEdicion) {
          <div class="row g-3">
            <div class="col-md-6">
              <label class="form-label">Nombre</label>
              <input class="form-control" [value]="form.nombre" (input)="setFormField('nombre', $event)" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Usuario</label>
              <input class="form-control" [value]="form.usuario" (input)="setFormField('usuario', $event)" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Perfil</label>
              <select class="form-select" [value]="form.profile_id" (change)="setFormField('profile_id', $event)">
                <option value="">Seleccione perfil</option>
                @for (p of profiles; track p) {
                  <option [value]="p.id" [selected]="isProfileOptionSelected(p.id, p.name)">{{ p.name }}</option>
                }
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label">Sucursal</label>
              <select class="form-select" [value]="form.FK_COD_SURCUSU" (change)="setFormField('FK_COD_SURCUSU', $event)">
                <option value="">Sin sucursal</option>
                @for (s of sucursales; track s) {
                  <option [value]="s.COD_SURC" [selected]="isSucursalOptionSelected(s.COD_SURC)">{{ s.DIR_SURC }}</option>
                }
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label">Contraseña {{ modoEdicion ? '(opcional)' : '' }}</label>
              <input class="form-control" type="password" [value]="form.password" (input)="setFormField('password', $event)" />
            </div>
            <div class="col-md-6">
              <label class="form-label">Estado</label>
              <select class="form-select" [value]="form.estado" (change)="setFormField('estado', $event)">
                <option value="1">Activo</option>
                <option value="0">Inactivo</option>
              </select>
            </div>
            <div class="col-md-6">
              <label class="form-label">Teléfono</label>
              <input class="form-control" [value]="form.telefonousuario" (input)="setFormField('telefonousuario', $event)" />
            </div>
            <div class="col-12">
              <div class="form-check mb-0">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="chkOmitirValidacionIp"
                  [checked]="form.omitir_validacion_ip === '1'"
                  (change)="onOmitirValidacionIpChange($event)"
                  />
                <label class="form-check-label" for="chkOmitirValidacionIp">
                  Omitir validación de IP en login para este usuario
                </label>
              </div>
            </div>
            <!-- CONFIGURACIONES ESPECIALES -->
            @if (esPerfilAsesor() || serviciosInforme.length > 0 || cargandoServiciosInforme) {
              <div class="col-12">
                <div class="special-group">
                  <div class="special-group__header">Configuraciones especiales</div>
                  <!-- App Asesor -->
                  @if (esPerfilAsesor()) {
                    <div>
                      <div class="section-toggle" (click)="toggleSeccionAsesor()">
                        <span class="section-toggle__label">
                          <i class="material-icons" style="font-size:16px;vertical-align:middle">smartphone</i>
                          Configuracion App Asesor
                        </span>
                        <span class="section-toggle__chevron">{{ seccionAsesorAbierta ? '&#9662;' : '&#9656;' }}</span>
                      </div>
                      @if (seccionAsesorAbierta) {
                        <div class="section-content pt-3">
                          <div class="form-check mb-3">
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="chkAsistente"
                              [checked]="form.asistente === '1'"
                              (change)="onAsistenteChange($event)"
                              />
                            <label class="form-check-label" for="chkAsistente">¿Es asistente?</label>
                          </div>
                          <label class="form-label">Personal de ventas a cargo</label>
                          <select class="form-select mb-1" multiple size="6" (change)="onPersonalACChange($event)">
                            @for (asesor of asesoresDisponibles; track asesor) {
                              <option
                                [value]="asesor.nombre"
                                [selected]="isPersonalACSelected(asesor.nombre)">
                                {{ asesor.nombre }}
                              </option>
                            }
                          </select>
                          <small class="text-muted d-block mb-3">Mantén presionada tecla Ctrl/Cmd para selección múltiple.</small>
                          <label class="form-label">Menu App</label>
                          <div class="menu-app-box">
                            <table class="table table-sm align-middle mb-0">
                              <thead>
                                <tr>
                                  <th>Opción</th>
                                  <th class="text-center">Acceso</th>
                                </tr>
                              </thead>
                              <tbody>
                                @for (item of form.accesosAppAse; track item; let i = $index) {
                                  <tr>
                                    <td>
                                      <div class="menu-title">{{ item.title }}</div>
                                      <small class="text-muted">{{ item.description }}</small>
                                    </td>
                                    <td class="text-center">
                                      <input
                                        class="form-check-input"
                                        type="checkbox"
                                        [checked]="item.acceso"
                                        (change)="toggleAccesoMenu(i, $event)"
                                        />
                                    </td>
                                  </tr>
                                }
                              </tbody>
                            </table>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <!-- Informes RX -->
                  @if (serviciosInforme.length > 0 || cargandoServiciosInforme) {
                    <div
                      [class.mt-2]="esPerfilAsesor()">
                      <div class="section-toggle" (click)="toggleSeccionInforme()">
                        <span class="section-toggle__label">
                          <i class="material-icons" style="font-size:16px;vertical-align:middle">assignment</i>
                          Informes RX — servicios habilitados
                          @if (serviciosSeleccionados.length > 0) {
                            <span class="badge bg-primary ms-2">
                              {{ serviciosSeleccionados.length }} asignado(s)
                            </span>
                          }
                        </span>
                        <span class="section-toggle__chevron">{{ seccionInformeAbierta ? '&#9662;' : '&#9656;' }}</span>
                      </div>
                      @if (seccionInformeAbierta) {
                        <div class="section-content mt-2">
                          <small class="d-block text-muted mb-2">
                            Marca los servicios para los que este usuario puede generar informes RX.
                          </small>
                          @if (cargandoServiciosInforme) {
                            <div class="text-center py-2">
                              <div class="spinner-border spinner-border-sm" role="status"></div>
                            </div>
                          }
                          @if (!cargandoServiciosInforme) {
                            <div class="menu-app-box">
                              <table class="table table-sm align-middle mb-0">
                                <thead>
                                  <tr>
                                    <th>Servicio</th>
                                    <th>Código</th>
                                    <th class="text-center">Puede generar informe</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  @for (svc of serviciosInforme; track svc) {
                                    <tr>
                                      <td>{{ svc.NOM_PRO }}</td>
                                      <td><span class="badge bg-secondary">{{ svc.CODN_PRO }}</span></td>
                                      <td class="text-center">
                                        <input
                                          class="form-check-input"
                                          type="checkbox"
                                          [checked]="isServicioInformeSeleccionado(svc.COD_PRO)"
                                          (change)="toggleServicioInforme(svc.COD_PRO)"
                                          />
                                      </td>
                                    </tr>
                                  }
                                </tbody>
                              </table>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
      <div class="modal-footer">
        <button class="btn btn-outline-secondary" type="button" (click)="cerrarModal()">Cancelar</button>
        <button class="btn btn-primary" type="button" (click)="guardarUsuario()" [disabled]="guardando || cargandoEdicion || !canWrite">
          {{ guardando ? 'Guardando...' : 'Guardar' }}
        </button>
      </div>
    </div>
  </div>
}
